import { withInstall } from '@/utils/install'
import comp from './floatingWrapper.vue'

const FloatingWrapper = withInstall(comp)

export default FloatingWrapper